import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { JobItemMergeData } from './job.item.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Job,
})
export class JobIncludeItemsMergeData {
    @MergeField({
        arraySchemaName: 'JobItemMergeDataSchema',
    })
    items: JobItemMergeData[] = [];

    @MergeField()
    itemCount: number;
}

export const JobIncludeItemsMergeDataSchema = getSchema(JobIncludeItemsMergeData)